var userAgent = require('../internals/engine-user-agent');

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/engine-webkit-version.js
// module id = 607
// module chunks = 0 1